import { StateCreator } from 'zustand';
import { allSlices, bytePlusSlice } from './interface';

const createBytePlusSlice: StateCreator<allSlices, [], [], bytePlusSlice> = (set) => ({
  users: [],
  speakers: [],
  object: {},
  isScreenShared: false,
  tracks: { audio: false, video: false },

  setUsers: (users) =>
    set((state) => {
      return { byteplus: { ...state.byteplus, users } };
    }),
  setSpeakers: (speakers) => set((state) => ({ byteplus: { ...state.byteplus, speakers } })),
  setObject: (object) => set((state) => ({ byteplus: { ...state.byteplus, object } })),
  setScreenShare: (ss) => set((state) => ({ byteplus: { ...state.byteplus, isScreenShared: ss } })),
  updateTracks: (tracks) => {
    const { audio, video } = tracks;

    if (typeof audio !== 'undefined') {
      set((state) => ({
        byteplus: { ...state.byteplus, tracks: { ...state.byteplus.tracks, audio } }
      }));
    }
    if (typeof video !== 'undefined') {
      set((state) => ({
        byteplus: { ...state.byteplus, tracks: { ...state.byteplus.tracks, video } }
      }));
    }
  }
});

export default createBytePlusSlice;
